import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box } from '@mui/material';

export function SortableItem(props) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    height: 'auto',
    position: 'relative',
    flexShrink: 0,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Box
        {...listeners}
        {...attributes}
        sx={{ position: 'absolute', left: '-30px', top: '10px', cursor: 'grab' }}
      >
        <DragIndicatorIcon />
      </Box>
      {props.children}
    </div>
  );
}
